import React, { useEffect, useCallback, useState} from 'react';
import CheckboxParameter from './CheckboxParameter.js';
import EffectParameterSlider from './EffectParameterSlider.js';
import ParameterKnob from 'components/knobs/ParameterKnob.js';
import {connect} from 'react-redux';

const WaveFolderComponent = ({effect, scrollContainer, sequencerEngine, effectNumber}) => { 
    return (
        <div>
        <div className="wave-folder">
          <ParameterKnob
            scrollContainer={scrollContainer}
            name='Stages'
            parameter={effect.stagesParameter}
            step={1}
            max={20}
            min={1}
          />
          <ParameterKnob
            scrollContainer={scrollContainer}
            name='Smoothness'
            parameter={effect.smoothnessParameter}
            step={0.1}
            max={12}
            min={1}
          />
        </div>
          <CheckboxParameter parameter={effect.overSampleParameter} name="Oversample"/>
          <EffectParameterSlider
            effectNumber={effectNumber}
            name='Drive'
            sequencerEngine={sequencerEngine}
            root={4}
            lfoEnabled={true}
            parameter={effect.driveParameter}
            isParameter={true}
            step={0.01}
            max={32}
            min={0.01}
          />
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WaveFolderComponent);
